import {
  ITEM_REQUIRED_FIELDS,
  type CreateItemRequest,
  type ItemCategory,
  type ItemResponse,
  type UpdateItemRequest,
} from "@stocks/shared";

/** 품목 폼 입력 값 (input 은 문자열로 다룬다) */
export interface ItemFormValues {
  name: string;
  category: ItemCategory | "";
  spec: string;
  baseUnit: string;
  safetyStock: string;
  description: string;
}

export const EMPTY_ITEM_FORM: ItemFormValues = {
  name: "",
  category: "",
  spec: "",
  baseUnit: "",
  safetyStock: "0",
  description: "",
};

export const toItemFormValues = (item: ItemResponse): ItemFormValues => ({
  name: item.name,
  category: item.category ?? "",
  spec: item.spec ?? "",
  baseUnit: item.baseUnit,
  safetyStock: String(Number(item.safetyStock)),
  description: item.description ?? "",
});

/** 카테고리별 필수 속성 여부 (원단·라벨은 규격 필수) */
export const isSpecRequired = (category: ItemCategory | "") =>
  category !== "" && ITEM_REQUIRED_FIELDS[category].includes("spec");

export const toCreateItemRequest = (
  values: ItemFormValues,
): CreateItemRequest => ({
  name: values.name.trim(),
  category: values.category as ItemCategory,
  spec: values.spec.trim() || undefined,
  baseUnit: values.baseUnit.trim(),
  safetyStock: Number(values.safetyStock) || 0,
  description: values.description.trim() || undefined,
});

export const toUpdateItemRequest = (
  values: ItemFormValues,
): UpdateItemRequest => ({
  ...toCreateItemRequest(values),
  // 수정에서는 빈 값으로 비우는 것도 허용한다.
  spec: values.spec.trim(),
  description: values.description.trim(),
});
